/**
 * モデル作成時のファイル追加（雛形の BPMN・起案フォーム・持ち込みの BPMN）で使う
 * multipart body。
 *
 * **保存先はパートのファイル名で決まる**（URL のパスだけでは決まらない）ので、
 * File には必ず名前を付ける。
 */
export function modelFileBody(fileName: string, contents: BlobPart): FormData {
  const body = new FormData();
  body.append("file", new File([contents], fileName));
  return body;
}
